import React from 'react';

import { ReservationDetails } from '../../types';
import { SimpleCard } from '../common';
import { getCheckinStatus } from './checkin-status.utils';

type Props = Pick<ReservationDetails, 'reservation'>;

function OnlineCheckinStatus({ reservation }: Props) {
  return <SimpleCard title="Online check-in Status">{getCheckinStatus(reservation)}</SimpleCard>;
}

export default OnlineCheckinStatus;
